import { motion } from "framer-motion";
import { BENEFITS } from "@/data/content";

export default function WhyUs() {
  return (
    <section className="py-16 md:py-32 bg-primary grain" data-testid="why-us-section">
      <div className="max-w-6xl mx-auto px-6 md:px-10 relative z-10">
        <div className="max-w-2xl mb-14">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-300 mb-3">Why Choose Us</p>
          <h2 className="font-heading text-4xl md:text-5xl font-medium tracking-tight text-white">
            Professional service without the stress
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
          {BENEFITS.map((b, i) => (
            <motion.div
              key={b.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="border-t border-white/20 pt-6"
              data-testid={`benefit-${i}`}
            >
              <span className="text-emerald-300 font-semibold text-sm tracking-wide">{b.n}</span>
              <h3 className="font-heading text-2xl text-white mt-3">{b.title}</h3>
              <p className="mt-2 text-white/70 leading-relaxed">{b.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
